<template>
  <div
    class="lg:px-20 md:px-12 px-4 lg:py-20 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20"
  >
    <div>
      <p class="fsize24-14 lh32px text-center font-semibold">
        ROSETTA LIFE & BRISTOL BLACK CARERS
      </p>
    </div>
    <div class="bg-color m-auto mt-2 rounded-md heightWidth"></div>
    <div
      class="mt-4 lg:w-7/12 md:w-7/12 w-4/5 m-auto lg:text-center md:text-center textleft"
    >
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        As carers, we work in close contact with those we look after.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        Our work involves being alert to the sensation of touch.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        Touch can be seen as a relationship between two people that involves
        listening and responding - the beginning of a dance.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        In this short video we explore this idea with a group of informal carers
        based in Bristol, Bristol Black Carers. We invite you to explore it too,
        at home, and let us know what you think. Put on some favourite music and
        try out a hand dance ... a foot dance ... a duet between fingers ... any
        dance and you will probably find new dances ...
      </p>
      <p class="lg:mt-2 md:mt-2 mt-1 sm-fsize14">
        Then send us a picture of you and those you care for in this
        relationship for our digital gallery.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        If you have any questions, contact us at
        <a href="mailto:info@rosettalife.org" class="textcolor underline"
          >info@rosettalife.org</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.textcolor {
  color: #4a0a4b;
}
.bg-color {
  background-color: #94abca;
}
.heightWidth {
  height: 25rem;
  width: 80%;
}
@media (max-width: 640px) {
  .heightWidth {
    height: 10rem;
    width: 80%;
  }
  .textleft {
    text-align: left !important;
  }
}
</style>
